var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => {
  props = {
    ...props,
    style: {
      display: 'inline-block',
      width: '1em',
      height: '1em',
      maxWidth: '100%',
      maxHeight: '100%',
      fill: 'currentColor',
      transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      flexShrink: 0,
      ...props.style
    }
  };
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.389 25c.396 0 .727-.145.99-.436l.089-.087.088-.087 14.048-13.993c.264-.261.396-.588.396-.98 0-.393-.132-.72-.396-.981C27.31 8.146 26.972 8 26.59 8c-.382 0-.72.145-1.013.436L12.367 21.6l-5.945-5.885c-.294-.29-.631-.436-1.013-.436-.381 0-.72.146-1.013.436a1.324 1.324 0 0 0-.396.981c0 .392.132.72.396.98l7.002 6.888c.264.29.595.436.991.436Z"
  })));
};
export default SvgCheck;